module.exports = __webpack_public_path__ + "assets/img/1aa2-ga.svg";